<template>
  <v-container fluid>
    <h2 class="mb-5">Pagrindinis</h2>
    <v-card class="dashboard">
      <v-card-text class="pa-0">
        <template v-if="roleNone">
          <v-container fluid>
            <v-alert dense outlined type="error">
              Jums nepriskirta nė viena rolė darbui su TURTAS. Atsiųskite ekrano
              vaizdą su šiuo pranešimu el. paštu info@registrucentras.lt
              <v-divider class="mt-3 mb-4" />
              <v-row>
                <v-col cols="12" md="2">Naudotojas</v-col>
                <v-col cols="12" md="10">{{ getUsername }}</v-col>
                <v-col cols="12" md="2">Įmonė</v-col>
                <v-col cols="12" md="10">{{ userKontora }}</v-col>
                <v-col cols="12" md="2">Sutartis</v-col>
                <v-col cols="12" md="10">{{ userSutartis }}</v-col>
              </v-row>
            </v-alert>
          </v-container>
        </template>
        <hipoteka-dashboard />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaDashboard from './../components/hipoteka/dashboard/HipotekaDashboard'
import userRole from './../mixins/userRole'

export default {
  name: 'Pagrindinis',
  components: {
    HipotekaDashboard,
  },
  mixins: [userRole],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getUsername', 'userKontora', 'userSutartis']),
  },
}
</script>
<style lang="scss" scoped>
.dashboard {
  min-height: 300px;
}
</style>
